<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';

    export let chipsdata = [
        {sz: "med", s: false, t: "Yes", i:"/img/Check.svg", cbf:()=>{$user_data.workingwithrealtor = true;}},
        {sz: "med", s: true, t: "No", i:"/img/X.svg", cbf:()=>{$user_data.workingwithrealtor = false;}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="Are you currently working with a Realtor?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>